import cn from "classnames";
import { AccordionGroup } from "components/shared/AccordionGroup";
import { Title } from "components/typography/Title";
import styles from "./FAQList.module.scss";
import { AccordionItemProps } from "@/components/shared/AccordionItem";
import { StrapiFaqItemComponentData } from "@/types/strapi/components/shared/faqItem";

export type FAQListProps = {
  id: string;
  heading: string;
  items: (AccordionItemProps | StrapiFaqItemComponentData)[];
  className?: string;
};

export const FAQList = ({ id, heading, items, className }: FAQListProps) => {
  return (
    <div key={id} className={cn(styles.wrapper, className)}>
      <Title id={id} level={3} tag={2} className={styles.heading}>
        {heading}
      </Title>
      <AccordionGroup items={items} />
    </div>
  );
};
